import config from './config.js'

export default {

  viewparams: {"page":1,"rows":20,"search":"","sort":"id","sdir":"asc"},

  // list customer selection from server
  list: function(cb_success) {
    var u = config.baseUrl + 'rest/handuser/users?page=' + this.viewparams.page + '&rows=' + this.viewparams.rows + '&sidx=' + this.viewparams.sort + '&sord=' + this.viewparams.sdir;
    if (this.viewparams.search.length > 0) {
      console.log('search: ' + this.viewparams.search);
      u += '&search=' + encodeURIComponent(this.viewparams.search);
    }
    fetch(u,{credentials: 'include'}).then(resp => resp.json()).then(function(data) {
      cb_success(data);
    });
  },

  load: function(ctrl,id,cb_success) {
    config.get(ctrl,config.baseUrl + 'rest/handuser/users/' + encodeURIComponent(id),'Vertreter laden',cb_success);
  },

  save: function(ctrl,data,cb_success) {
    config.post(ctrl,config.baseUrl + 'rest/handuser/users/' + encodeURIComponent(data.id),'Vertreter speichern',JSON.stringify(data),cb_success);
  },

  deleteUser: function(ctrl,id,cb_success) {
    config.delete(ctrl,config.baseUrl + 'rest/handuser/users/' + encodeURIComponent(id),'Vertreter löschen.',cb_success);
  },

  savelogin: function(ctrl,login,cb_success) {
    config.post(ctrl,config.baseUrl + 'rest/handuser/logins','iHand Login speichern',JSON.stringify(login),cb_success);
  },

  listselections: function(handid,start,count) {
    var filter = [{"field":"hand_id","op":"equals","value":handid}];
    var url = config.baseUrl + 'rest/handuser/selections?start=' + encodeURIComponent(start) + '&count=' + encodeURIComponent(count) + "&filter=" + encodeURIComponent(JSON.stringify(filter));
    return fetch(url).then(resp => resp.json());
  },

  saveselection: function(entry) {
      return fetch(config.baseUrl + 'rest/handuser/selections',{method: 'POST', body:JSON.stringify(entry)});
  },

  deleteselection: function(handid,map_id) {
    var filter = [{"field":"hand_id","op":"equals","value":handid},{"field":"map_id","op":"equals","value": map_id}];
    var url = config.baseUrl + 'rest/handuser/selections&filter=' +  encodeURIComponent(JSON.stringify(filter));
    return fetch(url,{method: 'DELETE',credentials: 'include'});
  }

}
